import './style/index.less';
import WeChatLogin from './WeChatLogin';

export default WeChatLogin;
